import React, { useContext, useState } from "react";

import { Link } from "react-router-dom";
import { Row, Col, Form, FloatingLabel, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import "react-form-wizard-component/dist/style.css";

export default function AddNewPrayer() {
  const [values, setValues] = useState({
    selectFamily: "",
    prayerRequest: "",
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setValues((prevState) => ({
        ...prevState,
        [name]: files[0],
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(values);
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {"New Prayer Request Record"}
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Prayer Requests"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"Add New Prayer"}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <div className="card">
        <div className="card-header">New Prayer Request</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <Row>
              <Form.Group md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Select Family"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectFamily"
                    placeholder=""
                    value={values.selectFamily}
                    onChange={handleChange}
                  >
                    <option>Select Family...</option>
                    <option>FSF 1</option>
                    <option>FSF 3</option>
                    <option>FSF 4</option>
                    <option>FSF 5</option>
                    <option>FSF 6</option>
                    <option>FSF 7</option>
                    <option>FSF 8</option>
                    <option>FSF 9</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group>
                <FloatingLabel controlId="floatingInputGrid" label="Add Prayer">
                  <Form.Control
                    as="textarea"
                    required
                    type="text"
                    name="prayerRequest"
                    value={values.prayerRequest}
                    onChange={handleChange}
                    placeholder="Prayer Request"
                    style={{ height: "80px" }}
                  />
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Button className="py-2 my-3" variant="success" type="submit">
              Add Prayer
            </Button>
          </form>
        </div>
      </div>
    </PageLayout>
  );
}
